import styled from "styled-components";
import { rem } from "polished";
import React from "react";

const Title = styled.h3`
  padding: ${rem(14)} 0;
  display: flex;
  border-top: 1px solid #dbdbdb;
  font-size: ${rem(20)};
  justify-content: space-between;
  color: #5b5a50;
`;

const Price = styled.span`
  font-size: ${rem(15)};
  align-self: center;
  color: #5c5e62;
  font-family: sans-serif;
`;

export const Section = styled.div`
  padding: ${rem(4)} 0 ${rem(28)} 0;
  border-top: 1px solid #dbdbdb;
`;

export const SectionRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: ${rem(13)};
  line-height: 1.5;
  color: #5c5e62;
  font-family: sans-serif;
  margin-top: ${rem(2)};

  &:first-of-type {
    margin-top: 0;
  }

  &:nth-of-type(2) {
    margin-top: 0;
  }

  strong {
    font-weight: 700;
    font-size: ${rem(15)};
    color: #000;
  }
`;

const OverviewContainer = ({ title, totalPrice, children }) => {
  return (
    <>
      <Title>
        {title}
      </Title>
      {children}
    </>
  );
};

export default OverviewContainer;
